export enum TeamworkCommerceReturnPurposeTextSource {
  REASON = "reason",
  FIRST_REASON_CODE = "first_reason_code",
  LAST_REASON_CODE = "last_reason_code",
}

export const DEFAULT_TEAMWORK_COMMERCE_RETURN_PURPOSE_TEXT_SOURCE =
  TeamworkCommerceReturnPurposeTextSource.LAST_REASON_CODE;

export const DEFAULT_TEAMWORK_COMMERCE_RETURN_PURPOSE_TEXT_FALLBACK = "Return";
